import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const MusicCreatorsTable = () => {
  const navigate = useNavigate();
  
  // Extended sample data for music creators
  const [musicCreators, setMusicCreators] = useState([
    { id: 1, srNo: 1, firstName: 'Alex', lastName: 'Thompson', orders: 23, active: true },
    { id: 2, srNo: 2, firstName: 'Emma', lastName: 'Davis', orders: 19, active: true },
    { id: 3, srNo: 3, firstName: 'Chris', lastName: 'Brown', orders: 15, active: false },
    { id: 4, srNo: 4, firstName: 'Lisa', lastName: 'Miller', orders: 27, active: true },
    { id: 5, srNo: 5, firstName: 'Michael', lastName: 'Wilson', orders: 34, active: true },
    { id: 6, srNo: 6, firstName: 'Sarah', lastName: 'Johnson', orders: 22, active: false },
    { id: 7, srNo: 7, firstName: 'David', lastName: 'Lee', orders: 18, active: true },
    { id: 8, srNo: 8, firstName: 'Jennifer', lastName: 'Taylor', orders: 29, active: true },
  ]);

  const toggleMusicCreatorStatus = (id) => {
    setMusicCreators(musicCreators.map(creator => 
      creator.id === id ? { ...creator, active: !creator.active } : creator
    ));
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen  p-6">
      <div className="max-w-[1800px] mx-auto">
        {/* Header Section */}
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-3xl font-bold text-gray-800">Music Creators Details</h1>
            <p className="text-gray-600 mt-2">Manage and view all music creators information</p>
          </div>
          <button
            onClick={handleBack}
            className="bg-gradient-to-br from-orange-500 to-orange-600 text-white px-6 py-2 rounded-lg text-sm font-medium transition-colors duration-300 "
          >
            Back to Dashboard
          </button>
        </div>

        {/* Music Creators Table */}
        <div className="bg-white rounded-lg shadow-md p-6">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-gray-200 bg-gray-50">
                  <th className="text-left py-4 px-4 text-sm font-semibold text-gray-700 uppercase tracking-wider">
                    Sr No
                  </th>
                  <th className="text-left py-4 px-4 text-sm font-semibold text-gray-700 uppercase tracking-wider">
                    First Name
                  </th>
                  <th className="text-left py-4 px-4 text-sm font-semibold text-gray-700 uppercase tracking-wider">
                    Last Name
                  </th>
                  <th className="text-left py-4 px-4 text-sm font-semibold text-gray-700 uppercase tracking-wider">
                    Orders
                  </th>
                  <th className="text-left py-4 px-4 text-sm font-semibold text-gray-700 uppercase tracking-wider">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {musicCreators.map((creator) => (
                  <tr 
                    key={creator.id} 
                    className="border-b border-gray-100 hover:bg-gray-50 transition-colors duration-150"
                  >
                    <td className="py-4 px-4 text-sm text-gray-800 font-medium">
                      {creator.srNo}
                    </td>
                    <td className="py-4 px-4 text-sm text-gray-800">
                      {creator.firstName}
                    </td>
                    <td className="py-4 px-4 text-sm text-gray-800">
                      {creator.lastName}
                    </td>
                    <td className="py-4 px-4 text-sm text-gray-800">
                      <span className="inline-flex items-center justify-center w-8 h-8 bg-purple-100 text-purple-800 rounded-full text-xs font-medium">
                        {creator.orders}
                      </span>
                    </td>
                    <td className="py-4 px-4">
                      <div className="flex items-center space-x-4">
                        <label className="inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            checked={creator.active}
                            onChange={() => toggleMusicCreatorStatus(creator.id)}
                            className="sr-only peer"
                          />
                          <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-500"></div>
                        </label>
                        <span className={`text-sm font-medium ${
                          creator.active ? 'text-green-600' : 'text-red-600'
                        }`}>
                          {creator.active ? 'Active' : 'Inactive'}
                        </span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Table Footer */}
          <div className="flex justify-between items-center mt-6 pt-4 border-t border-gray-200">
            <p className="text-sm text-gray-600">
              Showing {musicCreators.length} music creators
            </p>
            <div className="flex space-x-2">
              <button className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors duration-300">
                Previous
              </button>
              <button className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors duration-300">
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MusicCreatorsTable;